import { render } from "./ReportEnviron.vue?vue&type=template&id=060a3299"
import script from "./ReportEnviron.vue?vue&type=script&lang=js"
export * from "./ReportEnviron.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ReportEnviron.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "060a3299"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('060a3299', __exports__)) {
    console.log('reload')
    api.reload('060a3299', __exports__)
  }
  
  module.hot.accept("./ReportEnviron.vue?vue&type=template&id=060a3299", () => {
    console.log('re-render')
    api.rerender('060a3299', render)
  })

}


export default __exports__